/**
 * Language actions
 *
 * JavaScript
 *
 * @category    src\actions
 * @package     actions\lang-actions.js
 * @author      Jesús Armando Talavera Morán.
 * @copyright   2020-2051 laredoloads.com
 * @link        http://laredoloads.com
 */

export const actions = {
  /**
   * Obtains units and their info
   * @param {Object} commit
   * @param {Object} {unit ids, sort option}
   */
  languageSet ({commit}, language) {
      commit('langState', language)
  }
}
